import { render, staticRenderFns } from "./CostsTextInputField.vue?vue&type=template&id=c2d783e0&scoped=true&"
import script from "./CostsTextInputField.vue?vue&type=script&lang=js&"
export * from "./CostsTextInputField.vue?vue&type=script&lang=js&"
import style0 from "./CostsTextInputField.vue?vue&type=style&index=0&id=c2d783e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d783e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VTextarea})
